import styled from 'styled-components'

const StyledInput = styled.input`
  border: none;
  border-bottom: 2px solid #333;
  outline: none;
  padding: 5px;
  font-size: 1rem;
  background-color: transparent;
  transition: border-color 0.3s;
  color: #333;

  &::placeholder {
    color: #333;
  }

  &:focus {
    // border-bottom-color: #90d1a8;
  }
`

export default StyledInput
